import {createModel} from "~~/package/utils/ModelUtil";
import Model from "~~/package/mapper/Model";
import {EventSpeakerModel} from "~~/package/mapper/home/model/EventSpeakerModel";

export class EventDataModel extends Model {
    constructor(
        public engage: string = "",
        public engageColor: string = "",
        public type: string = "",
        public typeColor: string = "",
        public eventStartDate: string = "",
        public eventEndDate: string = "",
        public registrationStartDate: string = "",
        public registrationEndDate: string = "",
        public location: string = "",
        public language: string = "",
        public link: string = "",
        public price: string = "",
        public applyButtonText: string = "",
        public contentUrl: string = "",
        public speakers: EventSpeakerModel[] = []
    ) {
        super();
    }

    public get isEventEnded(): boolean {
        const eventEndTime = new Date(this.eventEndDate).getTime(); // 이벤트 종료 시간
        const currentTime = new Date().getTime(); // 현재 시간

        return currentTime > eventEndTime; // 현재 시간이 종료 시간보다 크면 true 반환
    }

    public get isUpcoming(): boolean {
        return new Date() < new Date(this.registrationStartDate);
    }

    public get isClosed(): boolean {
        return new Date() > new Date(this.registrationEndDate);
    }

    public get isRegisters(): boolean {
        const currentDate = new Date();
        return currentDate >= new Date(this.registrationStartDate) && currentDate <= new Date(this.registrationEndDate)
    }

    public static create(model: Partial<EventDataModel>): EventDataModel {
        return createModel<EventDataModel>(EventDataModel, {
            ...model,
            speakers: model.speakers?.map(speaker =>
                EventSpeakerModel.create(speaker)
            ) || []
        });
    }
}
